// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c4bb3202","339":"6fbd4b2e","709":"792276e4","810":"3e4c711d","843":"06509ee2","985":"4e578504"}[chunkId] + ".chunk.js";
};